export const newslist = [
  {
    index: 45,
    headline: "Protectt.ai wins 'Security Product Company of the Year' award",
    month: "December",
    quater_id: "q3",
    date: "22",
    year: "2023",
    publisher: "ET Government",
    description: "The company clinched this award in the highly competitive \"Product of the Year\" category.",
    link: "https://government.economictimes.indiatimes.com/news/secure-india/protectt-ai-wins-security-product-company-of-the-year-award/106218794?utm_source=whatsapp_web&utm_medium=social&utm_campaign=socialsharebuttons",
    img: "../../../assets/images/medianews/etgovernment-logo-400x40000.webp",
  },
  {
    index: 44,
    headline: "Protectt.ai launches a new version of AppProtectt",
    month: "august",
    quater_id: "q2",
    date: "11",
    year: "2023",
    publisher: "Financial Express",
    description: "According to an official release, Protectt.ai, a mobile threat defence and cybersecurity company, launched a new version of AppProtectt, a mobile app security platform (XDR)",
    link: "https://www.financialexpress.com/business/blockchain-protectt-ai-launches-a-new-version-of-appprotectt-3207860/",
    img: "../../../assets/images/medianews/financial.webp",
  },
  {
    index: 43,
    headline: "Protectt.ai launches new version of AppProtectt – Mobile App RunTime Security Platform (XDR)",
    month: "august",
    quater_id: "q2",
    date: "10",
    year: "2023",
    publisher: "Express Computer",
    description: "Protectt.ai, a leading Mobile Threat Defence & Cybersecurity company, launches its latest version of AppProtectt – Mobile App Security Platform (XDR), Extended Threat Detection & Response which offers RunTime Mobile App Security.",
    link: "https://www.expresscomputer.in/news/protectt-ai-launches-new-version-of-appprotectt-mobile-app-runtime-security-platform-xdr/102095/",
    img: "../../../assets/images/medianews/express.webp",
  },
  {
    index: 42,
    headline: "Building digital identity of mobile users, a must for banking and financial organisations",
    month: "july",
    quater_id: "q2",
    date: "16",
    year: "2023",
    publisher: "Times Of India",
    description: "As we shift rapidly towards a digitized world, financial activities are getting revolutionized. With the current rise of online frauds and cybercrimes, securing Digital Identity has become more important than ever.",
    link: "https://timesofindia.indiatimes.com/blogs/voices/building-digital-identity-of-mobile-users-a-must-for-banking-and-financial-organisations/",
    img: "../../../assets/images/medianews/times_of_india.webp",
  },
  {
    index: 41,
    headline: "How Mumbai-based Protectt.ai uses deep-tech to protect digital assets from cyber threats",
    month: "august",
    quater_id: "q2",
    date: "28",
    year: "2023",
    publisher: "Your Story",
    description: "In recent years, India has witnessed rapid digitisation, with almost 750 million smartphone users, with internet connectivity spreading far and wide to remote corners of the country.",
    link: "https://yourstory.com/2023/08/how-mumbai-based-protecttai-uses-deep-tech-protect-digital-assets",
    img: "../../../assets/images/medianews/your_story.webp",
  },
  {
    index: 40,
    headline: "Leading Mobile Threat Defence & cybersecurity company, Protectt.ai wins DSCI Innovation Box 2023 Award",
    month: "may",
    quater_id: "q2",
    date: "30",
    year: "2023",
    publisher: "CXO Today",
    description: "Protectt.ai, a leading Mobile Threat Defence & cybersecurity company, has been announced as the winner of the Innovation Box 2023 at the 10th edition of Data Security Council of India (DSCI).",
    link: "https://www.cxotoday.com/press-release/leading-mobile-threat-defence-cybersecurity-company-protectt-ai-wins-dsci-innovation-box-2023-award/",
    img: "../../../assets/images/medianews/cxo_today.webp",
  },
  {
    index: 39,
    headline: "Protectt.ai’s Mobile App Security Platform “AppProtectt” Recognized as winner of Banking Frontier Technoviti Award, 2023",
    month: "apr",
    quater_id: "q1",
    date: "26",
    year: "2023",
    publisher: "Mobility India",
    description: "Protectt.ai is proud to announce that its flagship Mobile App Security platform “AppProtectt” has been chosen as the winner of the Technoviti Award, 2023.",
    link: "https://www.mobilityindia.com/protectt-ais-mobile-app-security-platform-appprotectt-recognized-as-winner-of-banking-frontier-technoviti-award-2023/",
    img: "../../../assets/images/medianews/mobility.webp",
  },
  {
    index: 33,
    headline: "Emerging cyber threats: Top trends that will take the spotlight in 2023",
    month: "feb",
    quater_id: "q1",
    date: "16",
    year: "2023",
    publisher: "ET CISO",
    description: "As the world gradually emerges out of the unforeseen challenges in wake of the pandemic, a distinct takeaway has been the advent of a new normal, where organisations have decided not to halt the accelerated momentum",
    link: "https://ciso.economictimes.indiatimes.com/news/emerging-cyber-threats-top-trends-that-will-take-the-spotlight-in-2023/97984038",
    img: "../../../assets/images/medianews/ciso.webp",
  },
  {
    index: 32,
    headline: "Seven steps towards safe & secured banking app usage",
    month: "sep",
    quater_id: "q3",
    date: "07",
    year: "2022",
    publisher: "Times Of India",
    description: "Mobile banking is one of the fastest growing segments in the Indian financial market. Considering Indian Government’s key focus on Digital India initiatives",
    link: "https://timesofindia.indiatimes.com/blogs/voices/seven-steps-towards-safe-secured-banking-app-usage/",
    img: "../../../assets/images/medianews/times_of_india.webp",
  },
  {
    index: 38,
    headline: "4 Best Practices to Improve Mobile App Security",
    month: "apr",
    quater_id: "q1",
    date: "05",
    year: "2023",
    publisher: "Times Of India",
    description: "The recent cyberattack on Scandinavian airline SAS has put the need for robust mobile application security in the spotlight yet again.",
    link: "https://timesofindia.indiatimes.com/blogs/voices/4-best-practices-to-improve-mobile-app-security/",
    img: "../../../assets/images/medianews/times_of_india.webp",
  },
  {
    index: 31,
    headline: "Mobile threat defense: Crucial consideration for a digital-first ecosystem",
    month: "sep",
    quater_id: "q3",
    date: "20",
    year: "2022",
    publisher: "ET CIO",
    description: "Critical mobile apps can be embedded with runtime security controls that monitor and provide real-time security on customer’s device.",
    link: "https://cio.economictimes.indiatimes.com/news/corporate-news/mobile-threat-defense-crucial-consideration-for-a-digital-first-ecosystem/94316089",
    img: "../../../assets/images/medianews/cio.webp",
  },
  {
    index: 37,
    headline: "Mobile Security: Risks, Mitigation, and Best Practices for Protecting Your Data and Devices",
    month: "mar",
    quater_id: "q1",
    date: "23",
    year: "2023",
    publisher: "CXO Today",
    description: "In today’s world, mobile devices have become an integral part of our lives, both personally and professionally.",
    link: "https://www.cxotoday.com/interviews/mobile-security-risks-mitigation-and-best-practices-for-protecting-your-data-and-devices/",
    img: "../../../assets/images/medianews/cxo_today.webp",
  },
  {
    index: 34,
    headline: "Explained: How Cybercriminals Are Using Phishing And Social Engineering To Hack Mobile Phones",
    month: "mar",
    quater_id: "q1",
    date: "16",
    year: "2023",
    publisher: "ET IndiaTimes",
    description: "The threat of being hacked is the biggest concern amongst internet users in today’s digital world. Even the most advanced software is vulnerable to hackers because of the rapid pace at which cyberattacks are evolving.",
    link: "https://www.indiatimes.com/explainers/news/how-cybercriminals-are-using-phishing-and-social-engineering-to-hack-mobile-phones-595549.html",
    img: "../../../assets/images/medianews/indiatimes.webp",
  },
  {
    index: 35,
    headline: "Digital India Act: MoS Chandrasekhar Presents Details | Experts Tell News18 Why It Matters",
    month: "mar",
    quater_id: "q1",
    date: "16",
    year: "2023",
    publisher: "NEWS 18",
    description: "Union Minister of State for Electronics and Information Technology Rajeev Chandrasekhar presented the goal and design principles of the Digital India Act during the Digital India Dialogues in Bengaluru on March 9.",
    link: "https://www.news18.com/india/digital-india-act-mos-chandrasekhar-presents-details-experts-explain-why-it-matters-7264147.html",
    img: "../../../assets/images/medianews/news_18.webp",
  },
  {
    index: 36,
    headline: "Future of Fintech 2023",
    month: "mar",
    quater_id: "q1",
    date: "16",
    year: "2023",
    publisher: "CXO Today",
    description: "Fintech refers to any digital technology that might revolutionize the financial services industry by inspiring the creation of novel financial service models, apps, procedures, and products or improving those already in existence.",
    link: "https://www.cxotoday.com/cxo-bytes/future-of-fintech-2023/",
    img: "../../../assets/images/medianews/cxo_today.webp",
  },
  {
    index: 30,
    headline: "Budget 2024 Expectations: Will FM provide further clarity, direction on plans for digital rupee?",
    month: "jan",
    quater_id: "q1",
    date: "28",
    year: "2023",
    publisher: "First Post",
    description: "With Union Budget approaching, the talk of securing and ensuring ease of transaction in Central Bank Digital Currencies (CBDCs) is further gaining ground.",
    link: "https://www.firstpost.com/business/budget-2024-expectations-will-fm-provide-further-clarity-direction-on-plans-for-digital-rupee-12061072.html",
    img: "../../../assets/images/medianews/first_post.webp",
  },
  {
    index: 29,
    headline: "Protectt.ai unveils plans to fight mobile frauds and cyber threats",
    month: "jan",
    quater_id: "q1",
    date: "14",
    year: "2023",
    publisher: "Business India",
    description: "Manish Mimani is a man on a mission. On the eve of Republic Day 2023, Mimani is unveiling his latest initiative, ‘Protectech’.",
    link: "https://businessindia.co/magazine/protecttai-unveils-plans-to-fight-mobile-frauds-and-cyber-threats",
    img: "../../../assets/images/medianews/business_india.webp",
  },
  {
    index: 24,
    headline: "Sunita Handa, Protectt.ai on how can enterprises be one-up on cyber-attackers",
    month: "jan",
    quater_id: "q1",
    date: "13",
    year: "2023",
    publisher: "ET CIO",
    description: "Pandemic forced many enterprises to expeditiously digitize their offerings & processes in order to have a competitive edge in the market.",
    link: "https://cio.economictimes.indiatimes.com/news/digital-security/sunita-handa-protectt-ai-on-how-can-enterprises-be-one-up-on-cyber-attackers/96955399",
    img: "../../../assets/images/medianews/cio.webp",
  },
  {
    index: 26,
    headline: "SCADA & URTDSM: Govt Takes Steps to Boost Cyber Health of Power Infra after AIIMS Server Hack",
    month: "dec",
    quater_id: "q3",
    date: "22",
    year: "2022",
    publisher: "NEWS 18",
    description: "An expert told News18 that SCADA will allow for continuous monitoring and identification of vulnerable points, enabling service providers to take appropriate action",
    link: "https://www.news18.com/news/india/scada-urtdsm-govt-takes-steps-to-boost-cyber-health-of-power-infra-after-aiims-hack-attack-6664825.html",
    img: "../../../assets/images/medianews/news_18.webp",
  },
  {
    index: 27,
    headline: "Mobile Threat Defense:5 Things An App Provider Must Ensure",
    month: "dec",
    quater_id: "q3",
    date: "17",
    year: "2022",
    publisher: "BW DISRUPT",
    description: "The author of this article mentions the importance of the proliferation of Mobile App and the threats that come with their increasing usage.",
    link: "https://bwdisrupt.businessworld.in/article/Mobile-Threat-Defense-5-Things-an-App-provider-must-ensure/17-12-2022-458450/",
    img: "../../../assets/images/medianews/bw_disrupt.webp",
  },
  {
    index: 28,
    headline: "CXOTV news | Techplus Media’s Post",
    month: "dec",
    quater_id: "q3",
    date: "23",
    year: "2022",
    publisher: "Linked IN",
    description: "We're live with Manish Mimani, Founder & CEO, Protectt.ai Labs Pvt Ltd in an exclusive interaction with #CXOTVnews.",
    link: "https://www.linkedin.com/posts/cxotvnews_manish-mimani-founder-ceo-protecttai-activity-7010552650123374592-mx5x?utm_source=share&utm_medium=member_android",
    img: "../../../assets/images/medianews/linkedin.webp",
  },
  {
    index: 8,
    headline: "Seven steps towards safe & secured banking app usage",
    month: "sep",
    quater_id: "q3",
    date: "07",
    year: "2022",
    publisher: "Times Of India",
    description: "Manish Mimani, Founder and CEO of Protectt.ai, shares important insights about “Seven steps towards safe & secured banking app usage”",
    link: "https://timesofindia.indiatimes.com/blogs/voices/seven-steps-towards-safe-secured-banking-app-usage/",
    img: "../../../assets/images/medianews/times_of_india.webp",
  },
  {
    index: 14,
    headline: "Mobile threat defense: Crucial consideration for a digital-first ecosystem",
    month: "sep",
    quater_id: "q3",
    date: "20",
    year: "2022",
    publisher: "ET CIO",
    description: "Manish Mimani, Founder and CEO of Protectt.ai, shares important insights on building best-in-class mobile threat defence ecosystem",
    link: "https://cio.economictimes.indiatimes.com/news/corporate-news/mobile-threat-defense-crucial-consideration-for-a-digital-first-ecosystem/94316089",
    img: "../../../assets/images/medianews/cio.webp",
  },
  {
    index: 12,
    headline: "Protectt.ai: Keeping your mobile data secure from cyberthreats",
    month: "sep",
    quater_id: "q3",
    date: "19",
    year: "2022",
    publisher: "Financial Express",
    description: "Protectt.ai has developed a plug-and-play security component which can be integrated with mobile apps and by default it",
    link: "https://www.financialexpress.com/industry/technology/protectt-ai-keeping-your-mobile-data-secure-from-cyberthreats/2672717/",
    img: "../../../assets/images/medianews/financial.webp",
  },
  {
    index: 6,
    headline: "Invoking the ‘Women in Tech’ focus in the cybersecurity space",
    month: "aug",
    quater_id: "q2",
    date: "18",
    year: "2022",
    publisher: "ET CISO",
    description: "Sunita Handa, Principal Advisor at Protectt.ai opines that academic inclusion of cybersecurity in STEM education and continual learning and development are key drivers",
    link: "https://ciso.economictimes.indiatimes.com/news/invoking-the-women-in-tech-focus-in-the-cybersecurity-space/93628990",
    img: "../../../assets/images/medianews/ciso.webp",
  },
  {
    index: 20,
    headline: "There is a need to address & overcome threats on real-time basis",
    month: "nov",
    quater_id: "q3",
    date: "20",
    year: "2022",
    publisher: "Times Tech",
    description: "TimesTech in an exclusive interaction with Manish Mimani, Founder & CEO, Protectt.ai tried to know about the cybersecurity landscape, the company’s pioneering endeavour to propagate Mobile Threat Defense (MTD) into the market , and the innovation that it is doing.",
    link: "https://timestech.in/there-is-a-need-to-address-overcome-threats-on-real-time-basis/",
    img: "../../../assets/images/medianews/timestech.webp",
  },
  {
    index: 21,
    headline: "India at 75: Evolved role of cyber security in protecting the interests of Digital India",
    month: "nov",
    quater_id: "q3",
    date: "7",
    year: "2022",
    publisher: "PC Quest",
    description: "India is under global limelight as the country’s economy continues to march northward when world-over there is a pall of gloom on apprehensions related to recession.",
    link: "https://www.pcquest.com/india-at-75-evolved-role-of-cyber-security-in-protecting-the-interests-of-digital-india/",
    img: "../../../assets/images/medianews/pc_quest.webp",
  },
  {
    index: 22,
    headline: "Cybersecurity Awareness: Must For Edtech Ecosystem In India",
    month: "oct",
    quater_id: "q3",
    date: "28",
    year: "2022",
    publisher: "BW Education",
    description: "It is crucial for schools and universities to invest in safe and secure learning environments and help their students get the best digital learning in all possible ways",
    link: "http://bweducation.businessworld.in/article/Cybersecurity-Awareness-Must-For-Edtech-Ecosystem-In-India/28-10-2022-451993/",
    img: "../../../assets/images/medianews/BW_EDUCATION.webp",
  },
  {
    index: 23,
    headline: "Cybersecurity awareness is vital in the MobileVerse",
    month: "oct",
    quater_id: "q3",
    date: "28",
    year: "2022",
    publisher: "CIO News",
    description: "More important is that individuals understand the vulnerabilities in mobile usage and practice secure usage to bring a holistic change in the cybersecurity system",
    link: "https://cionews.co.in/cybersecurity-awareness-is-vital-in-the-mobileverse/",
    img: "../../../assets/images/medianews/cio_news.webp",
  },
  {
    index: 25,
    headline: "Startups: Growth Engine of New India",
    month: "nov",
    quater_id: "q3",
    date: "19",
    year: "2022",
    publisher: "Times Tech",
    description: "India has the world’s third-largest startup ecosystem followed by the United States and China.",
    link: "https://timestech.in/startups-growth-engine-of-new-india/",
    img: "../../../assets/images/medianews/timestech.webp",
  },
  {
    index: 5,
    headline: "Protectt.ai launches new product innovation centre at Chennai",
    month: "aug",
    quater_id: "q2",
    date: "05",
    year: "2022",
    publisher: "Financial Express",
    description: "Mobile threat defense startup Protectt.ai has expanded its reach with a facility at chennai.The new center will cater to the mobile threat defense",
    link: "",
    img: "../../../assets/images/medianews/financial.webp",
  },
  {
    index: 9,
    headline: "Protectt.ai – Building an AatmaNirbhar Bharat with Industry First Innovation",
    month: "sep",
    quater_id: "q3",
    date: "08",
    year: "2022",
    publisher: "Banking Frontiers",
    description: "Here is a list of 10 important features a CISO would desire from a mobile security solution standpoint.",
    link: "https://bankingfrontiers.com/protectt-ai-building-an-aatmanirbhar-bharat-with-industry-first-innovation-in-mobile-app-device-and-transaction-security/",
    img: "../../../assets/images/medianews/banking_front.webp",
  },
  {
    index: 2,
    headline: "Protectt.ai ropes in Sunita Handa as Principal Advisor",
    month: "jul",
    quater_id: "q2",
    date: "19",
    year: "2022",
    publisher: "Banking Frontiers",
    description: "Mobile threat defence (MTD) startup Protectt.ai has announced the appointment of BFSI industry veteran Sunita Handa",
    link: "https://bankingfrontiers.com/protectt-ai-ropes-in-sunita-handa-as-principal-advisor/",
    img: "../../../assets/images/medianews/banking_front.webp",
  },
  {
    index: 13,
    headline: "Mobile Banking Malware SOVA putting you on Tenterhooks?",
    month: "sep",
    quater_id: "q3",
    date: "19",
    year: "2022",
    publisher: "Express Computer",
    description: "Here are the quick three actions, mobile banking app services providers should take to fend off these Malware threats.",
    link: "https://www.expresscomputer.in/guest-blogs/mobile-banking-malware-sova-putting-you-on-tenterhooks/90113/",
    img: "../../../assets/images/medianews/express.webp",
  },
  {
    index: 11,
    headline: "International Programmer’s Day: Top tips from tech leaders that every coder should follow",
    month: "sep",
    quater_id: "q3",
    date: "12",
    year: "2022",
    publisher: "TECHGIG",
    description: "International Programmer’s Day is marked to honor and celebrate their nature of innovation. Read key takeaways from tech leaders",
    link: "https://content.techgig.com/career-advice/international-programmers-day-top-tips-from-tech-leaders-that-every-coder-should-follow/articleshow/94150490.cms",
    img: "../../../assets/images/medianews/tech_gig.webp",
  },
  {
    index: 10,
    headline: "Securing Digital India Must Extend to Mobile Devices",
    month: "sep",
    quater_id: "q3",
    date: "09",
    year: "2022",
    publisher: "Express Computers",
    description: "India’s ambitious objective of reaching the US$1 trillion digital economy must be carefully nurtured with a strong foundation of trust",
    link: "https://www.expresscomputer.in/guest-blogs/securing-digital-india-must-extend-to-mobile-devices/89820/",
    img: "../../../assets/images/medianews/express.webp",
  },
  {
    index: 7,
    headline: "Protectt.ai : Industry First Innovation in Mobile App Security Platform",
    month: "aug",
    quater_id: "q2",
    date: "20",
    year: "2022",
    publisher: "CIO Insider",
    description: "Protectt.ai offers a robust mobile app security framework that allows banks to deliver secured and enhanced user experience to their customers",
    link: "https://www.cioinsiderindia.com/vendor/-protecttai-industry-first-innovation-in-mobile-app-security-platform--cid-1485.html",
    img: "../../../assets/images/medianews/cio_insider.webp",
  },
  {
    index: 4,
    headline: "Protectt.ai launches new product innovation centre at Chennai",
    month: "aug",
    quater_id: "q2",
    date: "03",
    year: "2022",
    publisher: "CIO News",
    description: "Product Innovation Center will serve as hub to address the mobile app & transactions security needs of banking and financial enterprises",
    link: "https://cionews.co.in/protectt-ai-launches-new-product-innovation-centre/",
    img: "../../../assets/images/medianews/cio_news.webp",
  },
  {
    index: 3,
    headline: "Exclusive interview with Sunita Handa",
    month: "jul",
    quater_id: "q2",
    date: "20",
    year: "2022",
    publisher: "DQ Channels",
    description: "Sunita Handa has been appointed as the Principal Advisor to Protectt.ai. Here she talks about her work in digital technology",
    link: "https://www.dqchannels.com/interaction-sunita-handa-principal-advisor-protecttai/",
    img: "../../../assets/images/medianews/dq_channels.webp",
  },
  {
    index: 1,
    headline: "Protectt.ai ropes in industry veteran Sunita Handa as Principal Advisor",
    month: "jul",
    quater_id: "q2",
    date: "13",
    year: "2022",
    publisher: "DATAQUEST",
    description: "Pioneering mobile threat defence (MTD) start-up, Protectt.ai announced the appointment of BFSI industry veteran and popular digital transformation stalwart",
    link: "https://www.dqindia.com/protectt-ai-ropes-in-industry-veteran-sunita-handa-as-principal-advisor/",
    img: "../../../assets/images/medianews/data_quest.webp",
  },
  {
    index: 15,
    headline: "Cybersecurity Awareness: Must For Edtech Ecosystem In India",
    month: "oct",
    quater_id: "q3",
    date: "28",
    year: "2022",
    publisher: "BW Education",
    description: "It is crucial for schools and universities to invest in safe and secure learning environments and help their students get the best digital learning in all possible ways",
    link: "http://bweducation.businessworld.in/article/Cybersecurity-Awareness-Must-For-Edtech-Ecosystem-In-India/28-10-2022-451993/",
    img: "../../../assets/images/medianews/BW_EDUCATION.webp",
  },
  {
    index: 16,
    headline: "Cybersecurity awareness is vital in the MobileVerse",
    month: "oct",
    quater_id: "q3",
    date: "28",
    year: "2022",
    publisher: "CIO News",
    description: " More important is that individuals understand the vulnerabilities in mobile usage and practice secure usage to bring a holistic change in the cybersecurity system",
    link: "https://cionews.co.in/cybersecurity-awareness-is-vital-in-the-mobileverse/",
    img: "../../../assets/images/medianews/cio_news.webp",
  },
  {
    index: 17,
    headline: "Top 5 approaches to secure your mobile banking app",
    month: "sep",
    quater_id: "q3",
    date: "13",
    year: "2022",
    publisher: "DATAQUEST",
    description: "Here are 5 important factors that should constitute your approach to provide safety and security around your mobile banking app.",
    link: "https://www.dqindia.com/top-5-approaches-to-secure-your-mobile-banking-app/",
    img: "../../../assets/images/medianews/data_quest.webp",
  },
  {
    index: 18,
    headline: "Winning consumer trust through ‘peace of mind’ mobile banking experience",
    month: "sep",
    quater_id: "q3",
    date: "28",
    year: "2022",
    publisher: "ET BFSI",
    description: "With the emergence of UPI payments, which has seen massive adoption in the recent past, the preferred medium to avail financial services isincreasingly shifting to mobile devices and thereby, also leading to higher expectation for covenient-banking.",
    link: "https://bfsi.economictimes.indiatimes.com/news/industry/winning-consumer-trust-through-peace-of-mind-mobile-banking-experience/94513676",
    img: "../../../assets/images/medianews/BFSI.webp",
  },
  {
    index: 19,
    headline: "5 key skills that can make you become a cybersecurity expert",
    month: "oct",
    quater_id: "q3",
    date: "17",
    year: "2022",
    publisher: "People Matters",
    description: "The internet, smartphones, quantum computing, and other forms of technology are revolutionising every aspect of human life, including how we communicate, bank, shop, work, obtain the news, and entertain ourselves.",
    link: "https://www.peoplematters.in/article/skilling/5-key-skills-that-can-make-you-become-a-cybersecurity-nerd-35698",
    img: "../../../assets/images/medianews/PEOPLE.webp",
  },
];

export const months = [
  {
    id: 1,
    name: 'JANUARY',
    value: 'jan'
  },
  {
    id: 2,
    name: 'FEBRUARY',
    value: 'feb'
  },
  {
    id: 3,
    name: 'MARCH',
    value: 'mar'
  },
  {
    id: 4,
    name: 'APRIL',
    value: 'apr'
  },
  {
    id: 5,
    name: 'MAY',
    value: 'may'
  },
  {
    id: 6,
    name: 'JUNE',
    value: 'jun'
  },
  {
    id: 7,
    name: 'JULY',
    value: 'jul'
  }
  ,
  {
    id: 8,
    name: 'AUGUST',
    value: 'aug'
  },
  {
    id: 9,
    name: 'SEPTEMBER',
    value: 'sep'
  },
  {
    id: 10,
    name: 'OCTOBER',
    value: 'oct'
  },
  {
    id: 11,
    name: 'NOVEMBER',
    value: 'nov'
  },
  {
    id: 12,
    name: 'DECENBER',
    value: 'dec'
  }
]

export const quaters = [
  {
    id: 1,
    name: 'JANUARY - APRIL',
    value: 'q1'
  },
  {
    id: 2,
    name: 'MAY - AUGUST',
    value: 'q2'
  },
  {
    id: 3,
    name: 'SEPTEMBER - DECEMBER',
    value: 'q3'
  }
]
export const dates = [
  {
    id: 1,
    value: '01',
  },
  {
    id: 2,
    value: '02',
  },
  {
    id: 3,
    value: '03',
  },
  {
    id: 4,
    value: '04',
  },
  {
    id: 5,
    value: '05',
  },
  {
    id: 6,
    value: '06',
  },
  {
    id: 7,
    value: '07',
  }
  ,
  {
    id: 8,
    value: '08',
  },
  {
    id: 9,
    value: '09',
  },
  {
    id: 10,
    value: '10',
  },
  {
    id: 11,
    value: '11',
  },
  {
    id: 12,
    value: '12',
  },
  {
    id: 13,
    value: '13',
  },
  {
    id: 14,
    value: '14',
  },
  {
    id: 15,
    value: '15',
  },
  {
    id: 16,
    value: '16',
  },
  {
    id: 17,
    value: '17',
  },
  {
    id: 18,
    value: '18',
  },
  {
    id: 19,
    value: '19',
  },
  {
    id: 20,
    value: '20',
  },
  {
    id: 21,
    value: '21',
  },
  {
    id: 22,
    value: '22',
  },
  {
    id: 23,
    value: '23',
  },
  {
    id: 24,
    value: '24',
  },
  {
    id: 25,
    value: '25',
  },
  {
    id: 26,
    value: '26',
  },
  {
    id: 27,
    value: '27',
  },
  {
    id: 28,
    value: '28',
  },
  {
    id: 29,
    value: '29',
  },
  {
    id: 30,
    value: '30',
  },
  {
    id: 31,
    value: '31',
  }
]

export const years = [
  {
    id: 1,
    value: '2018',
  },
  {
    id: 2,
    value: '2019',
  },
  {
    id: 3,
    value: '2020',
  },
  {
    id: 4,
    value: '2021',
  },
  {
    id: 5,
    value: '2022',
  },
]